import CountDownTimer from "@/common/components/countdown-timer";
import { getOfficialDrawDateWithSuffix } from "@/lib/date";
import { Promotion } from "../models/giveaway";

function GiveawayDetailsHeader({ promotion }: { promotion: Promotion }) {
	const randomImageNumber = Math.floor(
		Math.random() * promotion.prize.images.length
	);
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${promotion.prize.images[randomImageNumber]?.url}`;

	return (
		<div className="relative overflow-hidden md:min-h-screen">
			<div className="flex w-full flex-col justify-between bg-white px-4 py-25 pb-0 [clip-path:url(#wave-clip)] md:h-screen md:flex-row md:px-37 md:py-61">
				{/* Left: Text Content */}
				<div className="flex flex-col gap-8 md:gap-16">
					{/* Prize Value */}
					<div className="bg-blue w-fit rounded-2xl p-3 md:p-4">
						<p className="web-heading-h4 text-blue-500">
							Valued AT ${promotion.prize.cost.toLocaleString()}
						</p>
					</div>

					{/* Title + Description */}
					<div className="flex flex-col gap-6">
						<div className="hidden max-sm:block">
							<p className="web-heading-h3">
								Win This: {promotion.prize.title}
							</p>
						</div>
						<div className="hidden md:block">
							<p className="web-heading-h1">
								Win This: {promotion.prize.title}
							</p>
						</div>
						<p className="web-body-b1">{promotion.prize.description}.</p>
					</div>

					{/* Draw Date */}
					<p className="web-heading-h4">
						Winner Drawn:{" "}
						<span className="web-heading-h4-regular max-sm:hidden">
							{getOfficialDrawDateWithSuffix(new Date(promotion.endDate))} 7:00
							pm
						</span>
						<span className="web-body-b1 md:hidden">
							{getOfficialDrawDateWithSuffix(new Date(promotion.endDate))} 7:00
							pm
						</span>
					</p>

					{/* Countdown */}
					<CountDownTimer targetDate={new Date(promotion.endDate)} />
				</div>

				{/* Right: Image */}
				<div className="h-full w-full rounded-[32px] bg-white max-sm:pt-5 max-sm:pb-5 md:h-112 md:w-1/2">
					<img
						src={prizeImage}
						alt={promotion.prize.title}
						className="h-full w-full rounded-[32px] object-cover"
					/>
				</div>
			</div>
		</div>
	);
}

export default GiveawayDetailsHeader;
